import { render, staticRenderFns } from "./dailyLife.vue?vue&type=template&id=4f7d12fc"
import script from "./dailyLife.vue?vue&type=script&lang=js"
export * from "./dailyLife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports